import React, { useEffect, useState } from 'react';
import {
  Typography,
  Box,
  Button,
  List,
  ListItem,
  makeStyles,
} from '@material-ui/core';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import {
  shouldDisplayVehicleType,
  getVehicleType,
} from '../../../VehicleConstants';
import TireSize from './TireSize';
import AddVehicleModal from './AddVehicleModal';
import { apiGet } from '../../../brainApi';
import { trackFullStoryEvent } from '../../../helper';

const useStyles = makeStyles((theme) => ({
  listRoot: {
    padding: 0,
    color: '#212B36',
    width: '100%',
    '& .MuiListItemIcon-root': {
      minWidth: 30,
    },
    '& .MuiListItem-gutters': {
      paddingTop: 1,
      paddingBottom: 1,
    },
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  listLabel: {
    fontWeight: '500',
    color: '#637381',
    width: '30%',
  },
  shipment: {
    alignItems: 'center',
    fontWeight: '600',
    color: '#000',
  },
  vehicleImg: {
    border: '1px solid #f3f3f3',
    height: 120,
    borderRadius: 5,
    position: 'relative',
    // Hide on print previews and PDFs
    '@media print': {
      display: 'none',
    },
  },
  licenseInfo: {
    lineHeight: 1.2,
  },
  licenseView: {
    position: 'absolute',
    bottom: 0,
    border: '1px solid whitesmoke',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    minWidth: 100,
    borderRadius: 5,
    padding: 2,
    background: 'rgb(249 249 249 / 60%);',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
    },
  },
  loader: {
    float: 'right',
    right: '10px',
    color: 'rgb(64, 169, 255)',
    fontSize: '13px',
  },
  loaderIcon: {
    float: 'right',
    right: '10px',
    fontSize: '20px',
    cursor: 'pointer',
  },
  fullWidth: {
    width: '100%',
  },
  gray: {
    color: '#888',
  },
  mainBox: {
    marginBottom: 24,
    '& h5': {
      fontWeight: 700,
    },
  },
  listItem: {
    marginBottom: 12,
    padding: 0,
  },
  listItemLast: {
    backgroundColor: 'rgba(145, 158, 171, 0.08)',
    borderRadius: 8,
    paddingTop: '5px !important',
    paddingBottom: '5px !important',
    display: 'grid',
    '& span': {
      width: '100%',
      marginBottom: 5,
    },
  },
  listValue: {
    width: '70%',
  },
}));

const UnifiedVehicle = ({
  swId,
  customer,
  vehicle,
  fetchAppointment,
  showTitle = true,
  trackUrl,
  proSize,
  ProQuantity,
  ProDetails,
  source
}) => {
  const classes = useStyles();

  const [motorImageUrl, setMotorImageUrl] = useState(null);
  const [isVehicleFormModalOpen, setIsVehicleFormModalOpen] = useState(false);

  useEffect(() => {
    if (vehicle?.id) {
      // Fetch vehicle to get motor_image_url
      apiGet(`/vehicle/${vehicle.id}`).then((res) => {
        setMotorImageUrl(res.motor_image_url);
      });
    }
  }, [vehicle]);

  const {
    engine_name,
    color,
    trim,
    license_plate_number,
    license_plate_state,
    vin,
    display_name,
  } = vehicle || {};
  const type = getVehicleType(vehicle);
  return (
    <>
      {showTitle && (
        <Box
          display="flex"
          justifyContent="space-between"
          className={classes.mainBox}
        >
          <Typography variant="h5" gutterBottom>
            Vehicle Info
          </Typography>
          {!vehicle && (
            <Button onClick={() => setIsVehicleFormModalOpen(true)}>
              ＋ Add Vehicle
            </Button>
          )}
        </Box>
      )}
      {!vehicle ? (
        <Typography className={classes.gray}>No vehicle on file</Typography>
      ) : (
        <>
          <Box display="flex">
            {/* {type === 'Automobile' && (
              <Box
                width="30%"
                p={1}
                className={`${classes.vehicleImg} ${classes.flexCenter}`}
              >
                {motorImageUrl ? (
                  <img
                    src={motorImageUrl}
                    alt="vehicle"
                    className={classes.fullWidth}
                  />
                ) : (
                  <DriveEtaIcon fontSize="large" />
                )}
                {license_plate_state && (
                  <Box className={classes.licenseView}>
                    <Typography
                      variant="caption"
                      className={classes.licenseInfo}
                    >
                      {`${license_plate_state}`}
                    </Typography>
                    <Typography
                      variant="caption"
                      className={classes.licenseInfo}
                    >
                      <b>{`${license_plate_number}`}</b>
                    </Typography>
                  </Box>
                )}
              </Box>
            )} */}
            <List className={classes.listRoot}>
              <ListItem className={classes.listItem}>
                <span className={classes.listLabel}>Vehicle </span>
                <span className={classes.listValue}> {source !== 'Amazon' && source !== 'AmazonMP' ? display_name : 'NA'} </span>
                {/* <Typography variant="body2" className={classes.listLabel}>
                  <b>{display_name}</b>
                </Typography> */}
              </ListItem>
              {shouldDisplayVehicleType() && (
                <ListItem className={classes.listItem}>
                  <span className={classes.listLabel}>Type </span>
                  <span className={classes.listValue}>{source !== 'Amazon' && source !== 'AmazonMP' ? type : 'NA'} </span>
                </ListItem>
              )}
              {trim && (
                <ListItem className={classes.listItem}>
                  <span className={classes.listLabel}>Trim </span>
                  <span className={classes.listValue}>{source !== 'Amazon' && source !== 'AmazonMP' ? trim : 'NA'}</span>
                </ListItem>
              )}
              {engine_name && (
                <ListItem className={classes.listItem}>
                  <span className={classes.listLabel}>Engine </span>
                  <span className={classes.listValue}>{source !== 'Amazon' && source !== 'AmazonMP' ? engine_name : 'NA'}</span>
                </ListItem>
              )}
              {color && (
                <ListItem className={classes.listItem}>
                  <span className={classes.listLabel}>Color </span>
                  <span className={classes.listValue}>{source !== 'Amazon' && source !== 'AmazonMP' ? color : 'NA'}</span>
                </ListItem>
              )}
              {vin && (
                <ListItem className={classes.listItem}>
                  <span className={classes.listLabel}>VIN </span>
                  <span className={classes.listValue}>{source !== 'Amazon' && source !== 'AmazonMP' ? vin : 'NA'}</span>
                </ListItem>
              )}
              {ProDetails === null ||
              ProDetails === 0 ||
              ProDetails === '0' ? null : (
                <ListItem className={classes.listItem}>
                  {/* <Typography variant="body2" className={classes.serviceList}> */}
                  <span className={classes.listLabel}>Tire Details </span>
                  <span className={classes.listValue}>{source !== 'Amazon' && source !== 'AmazonMP' ? ProDetails : 'NA'}</span>
                  {/* </Typography> */}
                </ListItem>
              )}
              {proSize === null || proSize === 0 || proSize === '0' ? null : (
                <ListItem className={classes.listItem}>
                  <span className={classes.listLabel}>Tire Size </span>
                  <span className={classes.listValue}>{source !== 'Amazon' && source !== 'AmazonMP' ? proSize : 'NA'}</span>
                </ListItem>
              )}
              {ProQuantity === null ||
              ProQuantity === 0 ||
              ProQuantity === '0' ? null : (
                <ListItem className={classes.listItem}>
                  <span className={classes.listLabel}>Tire Quantity </span>
                  <span className={classes.listValue}>{ProQuantity}</span>
                </ListItem>
              )}
              {trackUrl === null || trackUrl === 0 || trackUrl === '0' ? (
                <ListItem className={classes.listItem}>
                  <span className={classes.listLabel}>Order Status </span>
                  <span className={classes.listValue}>
                    Being Delivered Locally
                  </span>
                </ListItem>
              ) : (
                <ListItem className={classes.listItem}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={trackUrl}
                    onClick={() => {
                      trackFullStoryEvent('CTA_Appointment_Details_Track_Shipment', {
                        track_url: trackUrl,
                      });
                    }}
                  >
                    Track Shipment
                  </a>
                </ListItem>
              )}

              {/* <ListItem className={classes.listItemLast}>
               <span className={classes.listLabel}>Milage</span>
                39,478
              </ListItem> */}
            </List>
          </Box>

          <Box>
            <List className={classes.listRoot}>
              <TireSize vehicle={vehicle} />
            </List>
          </Box>
        </>
      )}
      {customer && swId && fetchAppointment && (
        <AddVehicleModal
          isOpen={isVehicleFormModalOpen}
          setIsOpen={setIsVehicleFormModalOpen}
          customer={customer}
          swId={swId}
          fetchAppointment={fetchAppointment}
        />
      )}
    </>
  );
};

export default UnifiedVehicle;
